import { render, staticRenderFns } from "./DrugsItem.vue?vue&type=template&id=86608008&scoped=true"
import script from "./DrugsItem.vue?vue&type=script&lang=js"
export * from "./DrugsItem.vue?vue&type=script&lang=js"
import style0 from "./DrugsItem.vue?vue&type=style&index=0&id=86608008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86608008",
  null
  
)

export default component.exports